import $ = require('jquery');
import vcardContactForm = require('diy/vcard/contactForm-web');

$(function() {
    vcardContactForm.init();
});



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/init-vcard.ts
 **/